import styled from 'styled-components';

export default styled.div`
  .config-secondary-actions {
    display: flex;
    flex-direction: row;
    .action {
      display: flex;
      margin: 0.5em 2em 0 0;
      text-decoration: none;
      color: #3E7697;
      font-size: 14px;
      svg {
        margin-right: 0.45em;
      }
    }
    .disable-action {
      display: flex;
      margin: 0.5em 2em 0 0;
      text-decoration: none;
      color: #999999;
      font-size: 14px;
      svg {
        margin-right: 0.45em;
      }
    }
    .download-action {
      display: none;
    }
  }
`;

export const Mobile = styled.div`
  .download-action {
    display: flex !important;
  }
  .print-action {
    display: none !important;
  }
`;
